// import external dependencies
import 'jquery';

// Import everything from autoload



import Splide from '@splidejs/splide';

new Splide( '#splide-team', {
	type: 'slide',
	perPage: 3,
	breakpoints: {
		1440: {
			perPage: 2,
			padding: {
				left : '0rem',
				right: '0rem',
				
			},
		},
		768: {
			perPage: 1,
		},
	},
  arrows: false,
  pagination: true,
  autoHeight: false,
  padding: {
	left : '0rem',
	right: '12rem',
	
},

  classes: {
		// Add classes for arrows.
		// arrows: 'splide__arrows your-class-arrows',
		// arrow : 'splide__arrow your-class-arrow',
		// prev  : 'splide__arrow--prev your-class-prev',
		// next  : 'splide__arrow--next your-class-next',
		
		// Add classes for pagination.
		pagination: 'splide__pagination', // container
		page      : 'splide__pagination__page w-4 h-4 block border rounded-full', // each button
	},



} ).mount();


new Splide( '#splide-team-mobile', {
	type: 'loop',
	perPage: 1,
  arrows: false,
  pagination: true,
  autoHeight: false,

  classes: {
		// Add classes for arrows.
		// arrows: 'splide__arrows your-class-arrows',
		// arrow : 'splide__arrow your-class-arrow',
		// prev  : 'splide__arrow--prev your-class-prev',
		// next  : 'splide__arrow--next your-class-next',
		
		// Add classes for pagination.
		pagination: 'splide__pagination', // container
		page      : 'splide__pagination__page w-4 h-4 block border rounded-full', // each button
	},



} ).mount();



// const pagination = splideTest.Components.Pagination.data.list;

// console.log(pagination);

// document.getElementById('place-pagination').appendChild(pagination);  

// splideTest.on( 'pagination:updated', function() {

//   let move = splideTest.Components.Pagination.data.list;
//   document.getElementById('place-pagination').appendChild(move);  

//   console.log(move);

//   console.log('Ive Moved');
// } );
